module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_5012.6329f065.png";